<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
  >
    <path
      d="M16 16.5L11.0001 11.5M12.6667 7.33333C12.6667 10.555 10.055 13.1667 6.83333 13.1667C3.61167 13.1667 1 10.555 1 7.33333C1 4.11167 3.61167 1.5 6.83333 1.5C10.055 1.5 12.6667 4.11167 12.6667 7.33333Z"
      stroke="#265957"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
